// Registers the service worker of `doc/base-ui-seo-pwa-i18n.md` 4 at the
// root scope of the current origin. The worker itself decides what it may
// cache; registering it on an account host is therefore safe, and that host
// is also where the Web Push subscription of phase 017 will need it.
export const SERVICE_WORKER_URL = "/service-worker.js"
export const SERVICE_WORKER_SCOPE = "/"

export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return

  window.addEventListener("load", () => {
    navigator.serviceWorker.register(SERVICE_WORKER_URL, { scope: SERVICE_WORKER_SCOPE }).catch(() => {
      // A refused registration (an insecure context, a blocked worker) leaves
      // the page an ordinary website, which it already is.
    })
  })
}
